import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';
import { GeneralError } from '../domain/errors/general.js';
import { Envs } from '../envs.js';

let GetCommentReplies = class GetCommentReplies {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(input) {
    return __awaiter(this, void 0, void 0, function* () {
      const response = yield this.httpClient.request({
        method: HttpMethod.GET,
        url: `${Envs.BFF_MEMBERS_AREA_URL}/hub/posts/${input.postId}/comments/${input.commentId}/replies`,
        params: {
          page: input.page,
          pageSize: input === null || input === void 0 ? void 0 : input.pageSize,
          orderDir: input === null || input === void 0 ? void 0 : input.orderDir
        }
      });
      if (response.statusCode === HttpStatusCode.CREATED || response.statusCode === HttpStatusCode.OK) {
        return response.data;
      }
      throw new GeneralError();
    });
  }
};
GetCommentReplies = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], GetCommentReplies);

export { GetCommentReplies };
